kv.controller('internalObjectListCtrl', function ($element, $attrs, $scope, $injector) {
	return new dictionaryListCtrl($element, $attrs, $scope, $injector, {
		primaryKey: "internal_object_id",
		entity: "internal_object",
		modal: {
			templateUrl: "internal_object-edit",
			controller: "internalObjectEditCtrl"
		}
	});
});
